import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { UpiMangeLayer } from '../components/userPoint/UpiMangeLayer'

export const UpiMangePage = () => {
  return (
    <MasterLayout>
        <UpiMangeLayer />
    </MasterLayout>
  )
}
